import type { ComponentProps } from 'react'
import InputLabelListItem from './InputLabelListItem'
import CheckboxButton from '../Checkbox/CheckboxButton'

type InputPropsNames = 'defaultChecked' | 'checked' | 'onChange' | 'disabled'
type InheritedCheckboxButtonProps = Pick<
  ComponentProps<typeof CheckboxButton>,
  InputPropsNames
>
type InheritedInputLabelListItemProps = Omit<
  ComponentProps<typeof InputLabelListItem>,
  'input' | 'ref' | 'onClick' | InputPropsNames
>

interface Props
  extends InheritedInputLabelListItemProps,
  InheritedCheckboxButtonProps {}

function CheckboxInputListItem({
  defaultChecked,
  checked,
  onChange,
  disabled,
  ...rest
}: Props) {
  return (
    <InputLabelListItem
      {...rest}
      input={
        <CheckboxButton
          defaultChecked={defaultChecked}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      }
    />
  )
}

export default CheckboxInputListItem
